var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoga(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 48.2891V57.2683",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5281 57.2686H10.4712C7.9274 57.2686 5.86523 55.2064 5.86523 52.6626C5.86523 50.1188 7.9274 48.0566 10.4712 48.0566H48.5281C51.0719 48.0566 53.1341 50.1188 53.1341 52.6626C53.1341 55.2064 51.0719 57.2686 48.5281 57.2686Z",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7898 57.2686H27.2104C25.0218 57.2686 23.2476 55.4943 23.2476 53.3057V52.0195C23.2476 49.8309 25.0218 48.0566 27.2104 48.0566H31.7898C33.9784 48.0566 35.7526 49.8309 35.7526 52.0195V53.3057C35.7526 55.4943 33.9784 57.2686 31.7898 57.2686Z",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8426 48.0571L18.3014 47.4028C20.391 44.4232 21.5121 40.8723 21.5121 37.2331V31.5831L19.7354 28.5936C15.4689 21.4146 16.6292 12.2541 22.551 6.36552L27.2102 1.73242C28.997 1.73242 30.004 1.73242 31.7909 1.73242L36.5148 6.42982C42.4065 12.2885 43.5884 21.391 39.3882 28.5599L37.617 31.5831V37.0503C37.617 40.2817 38.501 43.4514 40.1732 46.2164L41.2865 48.0569",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5503 6.36523L27.1451 12.1976",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5138 6.42969L31.8716 12.1977",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5002 25.5308C26.7702 25.5308 24.5571 23.3177 24.5571 20.5877V17.6696C24.5571 14.9397 26.7702 12.7266 29.5002 12.7266C32.2301 12.7266 34.4433 14.9396 34.4433 17.6696V20.5877C34.4431 23.3176 32.2301 25.5308 29.5002 25.5308Z",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 1.73242V12.727",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoga);
export default __webpack_public_path__ + "static/media/yoga.59410b095ee0d95aec00b16c6f6a754f.svg";
export { ForwardRef as ReactComponent };